<template>
  <div class="floating-whatsapp-button" @click="openWhatsApp">
    <img src="@/assets/whatsapp-icon.png" alt="WhatsApp Icon" class="whatsapp-icon" />
    <span class="help-text">Precisa de Ajuda?</span>
  </div>
</template>

<script>
import {URL_API} from '../../config/api';
import axios from 'axios';
export default {
  data() {
    return {
      whatsappNumber: '',
    };
  },
  created() {
    console.log('FloatingWhatsAppButton created');
    this.fetchWhatsAppNumber();
  },
  methods: {
    async fetchWhatsAppNumber() {
      try {
        const response = await axios.get(`${URL_API}/help_numbers`);
        this.whatsappNumber = response.data[0].phone;
        console.log('Número do WhatsApp:', response.data);
      } catch (error) {
        console.error('Erro ao buscar o número do WhatsApp', error);
      }
    },

    openWhatsApp() {
      const url = `https://wa.me/${this.whatsappNumber}?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20meu%20cadastro%20na%20Xtreme%21`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.floating-whatsapp-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
}

.whatsapp-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
}

.help-text {
  font-size: 18px;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
}

@media (max-width: 720px) {
  .floating-whatsapp-button {
    bottom: 8px;
    right: 8px;
  }

  .whatsapp-icon {
    width: 36px;
    height: 36px;
  }

  .help-text {
    font-size: 12px;
  }
}

@media (max-width: 450px) {
  .floating-whatsapp-button {
    bottom: 4px;
    right: 4px;
  }

  .whatsapp-icon {
    width: 32px;
    height: 32px;
  }

  .help-text {
    font-size: 10px;
  }
}
</style>